import React, { useState } from "react";
import InputField from "../sharedComponents/InputField";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../slices/1-auth/1-login/thunk";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/Logo.webp";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import MainButton from "../sharedComponents/MainButton";

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslation();


  /* ================= STATIC CONTENT ================= */
  const formText = {
    title: t("resetPassword.title"),
    subtitle: t("resetPassword.subtitle"),
    otpPlaceholder: t("resetPassword.otpPlaceholder"),
    savePasswordText: t("resetPassword.savePasswordText"),
    resendText: t("resetPassword.resendText"),
    additionalText: t("resetPassword.additionalText"),
    newPasswordLabel: t("resetPassword.newPasswordLabel"),
    emailPlaceholder: t("resetPassword.emailPlaceholder"),
    passwordText: t("resetPassword.passwordText"),
    passwordPlaceholder: t("resetPassword.passwordPlaceholder"),
    passwordPlaceholderNew: t("resetPassword.passwordPlaceholderNew"),
    signInText: t("resetPassword.signInText")
  };


  const handleSubmit = async (e) => {
    const token = new URLSearchParams(window.location.search).get("token");
    e.preventDefault();
    // console.log(token);
    if (newPassword !== confirmPassword) {
      // toast.error("Passwords do not match");
      return;
    }
    const passwordData = {
      newPassword,
      confirmPassword,
    };
    try {
      await dispatch(resetPassword({ token, passwordData })).unwrap();
      // toast.success(result?.message || "Password reset successful");
      navigate("/");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      // toast.error(err || "Something went wrong");
    }
  };
  const isFormValid =
    newPassword.trim() !== "" &&
    confirmPassword.trim() !== "" &&
    newPassword === confirmPassword;
  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
      {/* Left Side */}
      <div className="flex-col items-center justify-center hidden min-h-screen text-center md:flex dark:bg-bg-dark-secondary bg-bg-light-secondary">
        <img
          src={logo}
          alt={t("signup.logoAlt")}
          className="flex items-center justify-center mb-6 rounded-full w-28 h-28 shadow-glow"
        />
        <h1 className="mb-4 text-3xl font-bold text-black dark:text-white">{t("signup.brandName")}</h1>
        <p className="px-4 text-center text-text-muted-light dark:text-text-muted-dark">{t("signup.brandSubtitle")}</p>
      </div>

      <div className="flex flex-col justify-center max-w-lg mx-auto md:my-6 md:gap-2">
        <div className="flex flex-col justify-center md:my-6 md:gap-4 md:mx-12 md:w-full">
        <div className="justify-center mb-4 md:justify-start">
          <span className="inline-block p-2 rounded-full">
            <LockClosedIcon className="w-12 h-12 p-3 rounded-full dark:text-primary text-primary-light dark:bg-bg-dark-tertiary bg-bg-light-tertiary" />
          </span>
          <h2 className="text-2xl font-bold md:text-3xl text-custom-black">
            {formText.title}
          </h2>
          <p className="mt-3 text-custom-black">{formText.subtitle}</p>
        </div>

        <form className="flex flex-col gap-5 mt-6" onSubmit={handleSubmit}>
          <InputField
            type="password"
            placeholder={formText.passwordPlaceholder}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <InputField
            type="password"
            placeholder={formText.passwordPlaceholderNew}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          <MainButton
            type="submit"
            disabled={!isFormValid}
          >
            {formText.signInText}
          </MainButton>
        </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
